module.exports = __webpack_public_path__ + "img/Photo_Georgia_Ntatsi.e5028dde.jpg";